/**
 * Container Width Strategy — px-mapping for
 * Component_Registry2.Container_Width_Strategy_ID (INT, nullable).
 *
 * Backed by TGAUI.fk_Container_Width_Strategy (added 2026-09-11, exposed via
 * @Manage=16 on /api/cr2-registry). That table is the source of truth for the
 * label/ID list shown in dropdowns (see scr_tgc_10378_component_registry_crud.tsx,
 * which fetches it live so new strategy codes can be added without a frontend
 * deploy). THIS file stays as the runtime id -> maxWidthPx lookup consumed by
 * ModuleHost.tsx and SequenceRouteLoader.tsx (synchronous, no DB round-trip on
 * every tab mount) — keep its IDs/maxWidthPx values in sync with the DB table
 * whenever a new strategy is added there.
 *
 * 0 / null / undefined = Unconstrained (default, matches historical full-flex behavior).
 */

export interface ContainerWidthStrategyOption {
    id: number;
    label: string;
    /** null = unconstrained (no maxWidth applied) */
    maxWidthPx: number | null;
}

export const CONTAINER_WIDTH_STRATEGIES: ContainerWidthStrategyOption[] = [
    { id: 0, label: 'Unconstrained (Full Width)', maxWidthPx: null },
    { id: 1, label: 'Narrow (600px)', maxWidthPx: 600 },
    { id: 2, label: 'Medium (900px)', maxWidthPx: 900 },
    { id: 3, label: 'Wide (1200px)', maxWidthPx: 1200 },
    { id: 4, label: 'Extra Wide (1600px)', maxWidthPx: 1600 },
];

/** Resolve a strategy code to its max-width in px, or undefined when unconstrained. */
export function getContainerMaxWidthPx(strategyId: number | null | undefined): number | undefined {
    if (!strategyId) return undefined;
    const match = CONTAINER_WIDTH_STRATEGIES.find((s) => s.id === strategyId);
    return match?.maxWidthPx ?? undefined;
}
